import { SimpleGrid, Button, Box, Container, Text } from "@chakra-ui/react";
import { useEffect, useState } from 'react'

export default function TrendingSearches() {
    const [searches, setTrendingSearches] = useState<any>([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/home-trending-searches`)
            .then((response) => response.json())
            .then((data) => setTrendingSearches(data));
    }, []);

    return (
        <Container maxW="1200px" py={20}>
        {/* Title */}
        <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={6}>
            TRENDING SEARCHES
        </Text>

        {/* Button Grid */}
        <SimpleGrid columns={{ base: 2, md: 6 }} spacing={6}>
            {searches.map((btn: { id: number; name: string}) => (
            <Button
                as="a"
                href={'/products/' + btn.name} 
                key={btn.id}
                bg="#33557b"
                color="white"
                _hover={{
                bg: "white",
                color: "#33557b",
                border: "1px solid #33557b",
                }}
                size={{ base: "sm", sm: "md", md: "lg" }} 
                borderRadius="md"
                w="100%"
            >
                {btn.name}
            </Button>
            ))}
        </SimpleGrid>
        </Container>
    );
}
